import React, { useState } from 'react';
import styles from './styles.module.scss';

interface TabItem {
	id: string;
	title: string;
	content: React.ReactNode;
}

interface TabsProps {
	tabs: TabItem[];
	defaultActiveTab?: string;
	activeTab?: string;
	onTabChange?: (tabId: string) => void;
}

export default function Tabs({ tabs, defaultActiveTab, activeTab: externalActiveTab, onTabChange }: TabsProps) {
	const [internalActiveTab, setInternalActiveTab] = useState(defaultActiveTab || tabs[0]?.id);

	// Используем внешнее состояние если передано, иначе внутреннее
	const activeTab = externalActiveTab !== undefined ? externalActiveTab : internalActiveTab;

	const handleTabClick = (tabId: string) => {
		if (onTabChange) {
			onTabChange(tabId);
		} else {
			setInternalActiveTab(tabId);
		}
	};

	return (
		<div className={styles.tabs}>
			<div className={styles.tabHeaders}>
				{tabs.map(tab => (
					<button
						key={tab.id}
						className={`${styles.tabHeader} ${activeTab === tab.id ? styles.active : ''}`}
						onClick={() => handleTabClick(tab.id)}
					>
						{tab.title}
					</button>
				))}
			</div>
			<div className={styles.tabContent}>{tabs.find(tab => tab.id === activeTab)?.content}</div>
		</div>
	);
}
